import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { SkeletonModule } from 'primeng/skeleton';
import { TextareaModule } from 'primeng/textarea';
import { config, Subject } from 'rxjs';
import { NotificationsService } from '../../services/notifications.service';
import { Report } from '../../interfaces/report';
import { DatePickerModule } from 'primeng/datepicker';

@Component({
  selector: 'app-admin-reports-view',
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    RippleModule,
    InputTextModule,
    TranslocoDirective,
    DialogModule,
    FloatLabelModule,
    InputNumberModule,
    MultiSelectModule,
    SelectModule,
    TextareaModule,
    SkeletonModule,
    DatePickerModule
  ],
  templateUrl: './admin-reports-view.component.html',
  styleUrl: './admin-reports-view.component.scss'
})
export class AdminReportsViewComponent implements OnDestroy, AfterViewInit {
  //^ --------------------------------------------------------------------------------------
  //^ ---------------------- INIZIALIZZAZIONI ----------------------------------------------
  //^ --------------------------------------------------------------------------------------

  reports: Report[] = [
    // ---- Bikes ----
    {
      id: "bike_usage_by_model",
      name: "reports.bike_usage_by_model.name",
      description: "reports.bike_usage_by_model.description",
      icon: "bar_chart",

      category: "bikes",
      endpoint: "generateBikeUsageByModelReport"
    },
    {
      id: "bike_maintenance_by_model",
      name: "reports.bike_maintenance_by_model.name",
      description: "reports.bike_maintenance_by_model.description",
      icon: "engineering",
      category: "bikes",
      endpoint: "generateBikeMaintenanceByModelReport"
    },
    {
      id: "maintenance_triggers_progress",
      name: "reports.maintenance_triggers_progress.name",
      description: "reports.maintenance_triggers_progress.description",
      icon: "precision_manufacturing",
      category: "bikes",
      endpoint: "generateMaintenanceTriggersProgressReport"
    },

    // ---- Stations ----
    {
      id: "station_bike_distribution_detailed",
      name: "reports.station_bike_distribution_detailed.name",
      description: "reports.station_bike_distribution_detailed.description",
      icon: "local_shipping",
      category: "stations",
      endpoint: "generateStationBikeDistributionDetailedReport"
    },
    {
      id: "station_net_flow",
      name: "reports.station_net_flow.name",
      description: "reports.station_net_flow.description",
      icon: "trending_up",
      config: [
        { id: "dateRange", required: true }
      ],
      category: "stations",
      endpoint: "generateStationNetFlowReport"
    },

    // ---- Rides ----
    {
      id: "ride_duration_distance_distribution",
      name: "reports.ride_duration_distance_distribution.name",
      description: "reports.ride_duration_distance_distribution.description",
      icon: "timeline",
      config: [
        { id: "dateRange", required: true }
      ],
      category: "rides",
      endpoint: "generateRideDurationDistanceDistributionReport"
    },
    {
      id: "revenue_per_tariff_plan",
      name: "reports.revenue_per_tariff_plan.name",
      description: "reports.revenue_per_tariff_plan.description",
      icon: "euro",
      config: [
        { id: "dateRange", required: true }
      ],
      category: "rides",
      endpoint: "generateRevenuePerTariffPlanReport"
    }
  ];


  currentReportId: string | undefined

  get currentReport() {
    return this.reports.find(r => r.id === this.currentReportId);
  }

  reportConfig: any = {};

  //? ALTRO
  destroy$ = new Subject<void>();
  today = new Date();

  @ViewChild('configForm') configForm: NgForm | undefined;

  //^ --------------------------------------------------------------------------------------
  //^ ---------------------- LIFE CYCLE - EVENTI -------------------------------------------
  //^ --------------------------------------------------------------------------------------

  constructor(
    private http: HttpClient,
    private notifications: NotificationsService,
    private transloco: TranslocoService,
    @Inject('ENVIRONMENT') private ENV: any
  ) {
  }


  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit(): void {
  }

  //^ --------------------------------------------------------------------------------------
  //^ ---------------------- ALTRO ---------------------------------------------------------
  //^ --------------------------------------------------------------------------------------

  setActiveReport(report: Report) {
    this.configForm?.reset()
    this.currentReportId = report.id
    this.reportConfig = {};
  }

  generateReport() {
    if (!this.currentReport) return;
    const config = this.reportConfig;
    const endpoint = this.currentReport.endpoint;

    this.http.post(this.ENV.apiUrl + endpoint, config, { responseType: 'blob', observe: 'response' }).subscribe({
      next: (response) => {
        const contentDisposition = response.headers.get('Content-Disposition');
        let filename = 'report.xlsx'; // fallback

        if (contentDisposition) {
          const match = contentDisposition.match(/filename="(.+)"/);
          if (match && match[1]) {
            filename = match[1];
          }
        }

        const blob = response.body as Blob;
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      },
      error: (err) => {

      }
    });


  }

  //? ALTRO

}
